import React from 'react';
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import {Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Scheda04 = () => {

  return (<>
    <PageHeader
    title="Scheda 04"
    description="CRITERI ATTRIBUZIONE AMBITI ALLE TIPOLOGIE A, B, C"
    className="mb-3"
    >
    </PageHeader>
    
    <Card style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Text>
            <p>Per selezionare le varabili da considerare nella valutazione delle performance in relazione alla rispondenza degli interventi di sostenibilita’ a obblighi di legge o atti volontari, sono state individuate le seguenti tre tipologie di kpi per le azioni di mitigazione dei rischi, distinte tra quelle riguardanti gli stakeholder comuni e l’azienda e quelle riguardanti gli stakeholder fruitori e l’azienda:</p>
            <p><strong>Tipologia A</strong></p>
            <p>Kpi relativi a interventi comuni a tutte le aziende in quanto i livelli minimi di performance sono richiesti da leggi/norme/regolamenti, senza che si aggiungano interventi specifici volontari dell’azienda, evidenziando:</p>
<ul>
  <li>
    * per gli stakeholder comuni le maggiori opportunita’ per il contenimento degli impatti di cui beneficiano (ovviamente senza costi in quanto sostenuti dall’azienda) e per l’azienda le opportunita’ finanziarie correlate a quelle degli stakeholder in termini di minori costi (es. Accantonamenti a fondi per il rischio di mancato rispetto delle stesse leggi/norme/regolamenti), nonche’ i costi da essa sostenuti per contenere questi rischi, senza di norma ottenere dei contributi per il rispetto delle leggi 
  </li>
  <li>
     *per gli stakeholder fruitori le maggiori opportunita’ finanziarie della azienda derivanti dalla riduzione delle dipendenze da vincoli legislativi esterni, con i costi da essa sostenuti per perseguirle, senza di norma contributi per la riduzione di queste dipendenze
  </li>
</ul>
<p><strong>Tipologia B</strong></p>
<p>Kpi relativi ai soli interventi specifici volontari dell’azienda, in assenza di leggi/norme/regolamenti che li impongano, evidenziando:</p> 
<ul>
  <li>* per gli stakeholder comuni le maggiori opportunita’ per il contenimento degli impatti di cui beneficiano (ovviamente senza costi in quanto sostenuti dall’azienda) e per l’azienda le opportunita’ finanziarie correlate a quelle degli stakeholder in termini di maggiori ricavi o minori costi, a fronte dei costi per ottenerli ma anche dei contributi che puo’ ricevere per questi interventi volontari.</li>
  <li>* per gli stakeholder fruitori le maggiori opportunita’ finanziarie della azienda derivanti dalla riduzione delle dipendenze da fattori esterni che le condizionano, con i costi da essa sostenuti per perseguirle ma anche con eventuali contributi per la riduzione di queste dipendenze.</li>
</ul>
  <p><strong>Tipologia C</strong></p>
<p>Kpi che comprendono entrambe le tipologie a e b, in quanto i livelli minimi di performance comuni a tutte le aziende sono richiesti da leggi/norme e regolamenti, a cui si aggiungono pero’ anche interventi specifici volontari dell’ azienda, evidenziando:</p>
<ul>
  <li>* per gli stakeholder comuni le maggiori opportunita’ per il contenimento degli impatti e per l’azienda le opportunita’ finanziarie correlate a quelle degli stakeholder, oltre ai costi ed agli eventuali contributi gia’ visti per le tipologie a e b</li>
  <li>* per gli stakeholder fruitori le maggiori opportunita’ finanziarie della azienda derivanti dalla riduzione delle dipendenze da vincoli legislativi o fattori esterni, con i costi per ottenerle ed eventuali contributi gia’ visti per le tipologie a e b</li>
</ul>
          </Card.Text>
          <Card.Footer>
              <Link to="/app/metodologia/fase-a">
                <FontAwesomeIcon icon="chevron-left" className="ms-1 fs-11" />&nbsp;&nbsp;&nbsp;
                Torna all'elenco delle schede della fase A EFRAG 
              </Link>
           </Card.Footer>
        </Card.Body>
      </Card>

    </>)
};

export default Scheda04;
